module.exports = __webpack_public_path__ + "img/p1_l.f26e319a.jpg";